<script setup>

import { computed, watch }  from 'vue'

import { useConfigStore }   from '@/stores/config'
import { useLangStore }     from '@/stores/lang'
import { useTokenStore }    from '@/stores/token'
import { useWsStore }       from '@/stores/ws'
import { useProfileStore }  from '@/stores/profile'
import { useRouter }        from 'vue-router'

import UTAHeader from './components/UTAHeader.vue'
import UTAFooter from './components/UTAFooter.vue'

const router        = useRouter()

const tokenStore    = useTokenStore()
const configStore   = useConfigStore()
const langStore     = useLangStore()
const wsStore       = useWsStore()
const profileStore  = useProfileStore()

const token         = computed(() => tokenStore.access)
const profile       = computed(() => profileStore.profile)
const API_version   = computed(() => configStore.API_version)

const BASE_URL      = window.location.host
const BASE_PROTOCOL = window.location.protocol

// Определяем с какими серверами API будем работать [dev или dev/production]
if (import.meta.env.DEV) {
    configStore.httpServer = `/${API_version.value}`
    configStore.wsServer = `ws://${window.location.host}/ws`
} else {
    configStore.httpServer = BASE_PROTOCOL + '//' + BASE_URL + '/' + API_version.value
    configStore.wsServer = (BASE_PROTOCOL == 'http:' ? 'ws' : 'wss') + '://' + BASE_URL + '/' + API_version.value
}

langStore.setLang( localStorage.getItem('UTA_LANG') || 'RU' )

document.getElementsByTagName('html')[0].setAttribute('lang', langStore.lang.toLowerCase())

tokenStore.addToken().then(token => {
    if(token) {
        wsStore.openWs()
    }
})

// Перезагружаем приложение, если авторизовались в другом окне/вкладке
setInterval(() => {
    if(
        profile.value.uuid && 
        localStorage.getItem('UTA_UUID') && 
        profile.value.uuid !== localStorage.getItem('UTA_UUID')
    ) {
        document.location.reload()
    }
}, 2000)

watch(token, (newToken, oldToken) => {
    if(newToken && !oldToken) {
        wsStore.openWs()
        router.push('/')
    }
})

</script>

<template>
    <UTAHeader v-if="tokenStore.access" />
    <div class="uta__main">
        <RouterView />
    </div>
    <UTAFooter v-if="tokenStore.access" />
</template>
